import PasswordInputV1 from "../../../../components/form_builder/elements/password_input/PasswordInputV1.vue";
import {
  validateRequired,
  validateLengthGreaterEqualThan,
  validateLengthLessEqualThan
} from "../../../../helpers/validation";

export default {
  componentName: "fb-password-input-v1",
  component: PasswordInputV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      placeholder: "Write something...",
      description: "",
      value: "",
      required: false,
      hidden: false,
      readonly: false,
      minLength: 0,
      maxLength: null,
      style: {},
      eFormEditable: true,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) => (value ? "****" : "")
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    if (
      validateRequired(value) &&
      typeof properties.minLength != "undefined" &&
      !validateLengthGreaterEqualThan(value, properties.minLength)
    )
      errors.push(
        "This field length must be greater than " + properties.minLength
      );
    if (
      validateRequired(value) &&
      typeof properties.maxLength != "undefined" &&
      !validateLengthLessEqualThan(value, properties.maxLength)
    )
      errors.push(
        "This field length must be less than " + properties.maxLength
      );
    return errors;
  }
};
